import { render, staticRenderFns } from "./BeneficiariesYN.vue?vue&type=template&id=8314c88a"
import script from "./BeneficiariesYN.vue?vue&type=script&lang=js"
export * from "./BeneficiariesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports